(function () {
  var STORAGE_KEY = 'apex_wishlist';

  var apexWishlist = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch (e) { return []; }
    },
    save: function (list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    },
    has: function (id) {
      return this.get().some(function (p) { return String(p.id) === String(id); });
    },
    add: function (product) {
      var list = this.get();
      if (!this.has(product.id)) { list.push(product); this.save(list); }
    },
    remove: function (id) {
      this.save(this.get().filter(function (p) { return String(p.id) !== String(id); }));
    },
    toggle: function (product) {
      if (this.has(product.id)) { this.remove(product.id); return false; }
      else { this.add(product); return true; }
    },
    count: function () { return this.get().length; },

    updateBadge: function () {
      var count = this.count();
      document.querySelectorAll('.apex-wl-badge').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    updateButtons: function () {
      var self = this;
      document.querySelectorAll('[data-apex-wishlist-btn]').forEach(function (btn) {
        var id = btn.dataset.productId;
        var active = self.has(id);
        btn.classList.toggle('apex-wishlist-btn--active', active);
        var label = btn.querySelector('.apex-wishlist-btn__label');
        if (label) {
          label.textContent = active
            ? (btn.dataset.removeLabel || 'Remove from Wishlist')
            : (btn.dataset.addLabel || 'Add to Wishlist');
        }
        var heart = btn.querySelector('.apex-wishlist-btn__heart');
        if (heart) {
          heart.setAttribute('fill', active ? '#e0001b' : 'none');
          heart.setAttribute('stroke', '#e0001b');
        }
      });
    },

    showToast: function (msg) {
      var old = document.getElementById('apex-wishlist-toast');
      if (old) old.remove();
      var t = document.createElement('div');
      t.id = 'apex-wishlist-toast';
      t.className = 'apex-wishlist-toast';
      t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('apex-wishlist-toast--show'); });
      setTimeout(function () {
        t.classList.remove('apex-wishlist-toast--show');
        setTimeout(function () { t.remove(); }, 300);
      }, 2500);
    },

    init: function () {
      var self = this;
      this.updateBadge();
      this.updateButtons();

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-apex-wishlist-btn]');
        if (!btn) return;
        e.preventDefault();
        var product = {
          id: btn.dataset.productId,
          title: btn.dataset.productTitle,
          url: btn.dataset.productUrl,
          image: btn.dataset.productImage,
          price: btn.dataset.productPrice,
          priceFormatted: btn.dataset.productPriceFormatted
        };
        var added = self.toggle(product);
        self.updateBadge();
        self.updateButtons();
        self.showToast(added
          ? (btn.dataset.addedMsg || 'Added to wishlist')
          : (btn.dataset.removedMsg || 'Removed from wishlist'));
      });
    }
  };

  window.apexWishlist = apexWishlist;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apexWishlist.init(); });
  } else {
    apexWishlist.init();
  }
})();
